import type { RouteObject } from "react-router";
import Patient from "./ui/pages/Patient";
import CouplePatientPage from "./ui/pages/CouplePatientPage";
import GroupPatientPage from "./ui/pages/GroupPatientPage";

/**
 * One patient's, couple's or group's record: the page that gathers their
 * sessions, plans, alerts and tools. It sits above those modules, which is why
 * it is not part of `patient` — the tools themselves read patients.
 */
export const patientRecordRoutes: RouteObject[] = [
    { path: "/patient/:id", element: <Patient /> },
    { path: "/couple-patient/:id", element: <CouplePatientPage /> },
    { path: "/group-patient/:id", element: <GroupPatientPage /> },
];
